/**
 * SearchInput Component
 *
 * Search input field for toolbars.
 */

import { forwardRef } from 'react';
import clsx from 'clsx';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onChange, placeholder = 'Cerca...', className }, ref) => {
    return (
      <div className={clsx('relative', className)}>
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-quaternary"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          ref={ref}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full pl-10 pr-10 py-2.5 rounded-lg bg-surface-tertiary/50 border border-border-primary text-[11px] text-text-primary placeholder:text-text-quaternary focus:outline-none focus:ring-2 focus:ring-accent-violet/30 focus:border-accent-violet/50 transition-colors"
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-lg hover:bg-surface-hover transition-colors"
          >
            <svg
              className="w-3 h-3 text-text-quaternary"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';
